import React from "react";

import type { ProcessedSingleSelection } from "@/hooks/firestore/betting/useEntries";

import cx from "classnames";
import { OutcomeIcon } from "@/features/shell/components/shared/OutcomeIcon";

import * as styles from "./SelectionIcon.module.scss";

type SelectionIconProps = {
  selection: ProcessedSingleSelection;
  className?: string;
};

const SelectionIcon = ({ selection, className }: SelectionIconProps) => (
  <OutcomeIcon
    className={cx(styles.outcomeIcon, className)}
    outcomeType={selection.outcomeType}
    competitor={selection.competitor ?? undefined}
    silksUrl={selection.event.attributes?.silksUrl}
    reserveAvatarSpace
  />
);

export { SelectionIcon };
